<div *ngIf='text' class='custom-tooltip'>
  <p class='text-white m-1'>
    {{ text }}
  </p>
</div>
